export const PDFAttachmentTypeVals = {
    Normal: 1,
    RequeryApprove: 2,
    FromExpertForGIP: 3,
    PaperSigningGenerated: 4,
    PaperSigningSigned: 5,
};
